var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, Fragment as ReactFragment } from 'react';
import { Alignment, Breakpoint, ButtonTheme, ButtonType, ModalType, Placement, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, eventListener, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { AbortableCloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { classNames, enumValues, getBreakpoint, isFunction, isMobile } from '@philips-internal/oswald-ui-utils';
import CustomContextMenuAPI from './custom-context-menu-api';
import './custom-context-menu.css';
import { Modal, Popover } from '@philips-internal/oswald-ui-components';
import { Button } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let CustomContextMenu = class CustomContextMenu extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onClick = () => {
            this.popoverToggle();
        };
        this.onItemClick = () => {
            this.popoverToggle();
        };
        this.popoverToggle = () => {
            if (this.state.open && !this.shouldClose()) {
                return;
            }
            const { onClose, onOpen } = this.props;
            if (this.state.open) {
                this.setState(({ open }) => ({ open: !open }), () => onClose);
                return;
            }
            this.setState(({ open }) => ({ open: !open }), () => onOpen);
        };
        this.shouldClose = () => {
            const { onBeforeClose } = this.props;
            let close = true;
            const abort = () => {
                close = false;
            };
            if (isFunction(onBeforeClose)) {
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            return close;
        };
    }
    static { this.propTypes = {
        alignment: oneOf(enumValues(Alignment)),
        children: oneOfType([element, arrayOf(element)]).notEnumerable(),
        onBeforeClose: eventListener,
        onClose: eventListener,
        onOpen: eventListener,
        placement: oneOf(enumValues(Placement)),
        uuid: string,
    }; }
    static { this.defaultProps = {
        alignment: Alignment.CENTER,
        placement: Placement.BOTTOM,
    }; }
    renderIcon() {
        return (React.createElement("div", { className: "c-context-menu__icon" },
            React.createElement(Button, { onClick: this.onClick, value: MessageService.translate('clinical-notes.add-notes'), enabled: true, size: Size.LARGE, type: ButtonType.BUTTON, fitParent: true, theme: ButtonTheme.PRIMARY })));
    }
    renderChildren() {
        const { children, uuid } = this.props;
        return (React.createElement(Container, { className: "u-expand", onClick: this.onItemClick, uuid: uuid }, children));
    }
    renderPopover() {
        const { alignment, placement } = this.props;
        const { open } = this.state;
        return (React.createElement(Popover, { alignment: alignment, className: "c-context-menu__popover", onClose: this.popoverToggle, open: open, padding: 4, placement: placement },
            this.renderIcon(),
            React.createElement(Popover.Content, null, this.renderChildren())));
    }
    renderModal() {
        const { open } = this.state;
        return (React.createElement(ReactFragment, null,
            this.renderIcon(),
            open &&
                React.createElement(Modal, { closeable: true, focusOnOpen: true, hideHeaderOnMobile: true, noPadding: isMobile(), onClose: this.popoverToggle, type: ModalType.DIALOG }, this.renderChildren())));
    }
    isMobileSize() {
        const breakpoint = getBreakpoint();
        return breakpoint === Breakpoint.XSM || breakpoint === Breakpoint.SM;
    }
    getClassName() {
        const { className } = this.props;
        return classNames({
            'c-context-menu': true,
            [`${className}`]: Boolean(className),
        });
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() }, this.isMobileSize() ? this.renderModal() : this.renderPopover()));
    }
};
CustomContextMenu = __decorate([
    AwesomeComponent({ api: CustomContextMenuAPI, type: ComponentType.NAVIGATION })
], CustomContextMenu);
export default CustomContextMenu;
//# sourceMappingURL=custom-context-menu.js.map